<icon-label [icon]="'arrow-simple-left'"
            [iconLink]="link"
            [textClass]="'h3'"></icon-label>

<div class="flex flex-justify-end w-12">
    <div class="flex flex-middle">
        @if (coins !== undefined) {
        <pwa-points-banner [points]="coins"
                           [text]="pointsText"
                           [type]="'coins'" />
        }
        @if (rosettes !== undefined) {
        <pwa-points-banner [points]="rosettes"
                           [text]="pointsText"
                           [type]="'rosettes'"
                           class="m-l-2" />
        }
    </div>
</div>
